<template>
  <main class="console-page-child add-account">
    <el-row class="console-title">添加用户账号</el-row>
    <div class="content-wrapper">
      <accountCommon ref="account" :type="'create'" />
    </div>
    <el-row class="btns-wrapper">
      <el-button type="primary" @click="addAccount" class="add-btn"
        >添加</el-button
      >
      <el-button @click="goBack()">返回</el-button>
    </el-row>
  </main>
</template>

<script>
import accountCommon from './account-common.vue'
export default {
  components: {
    accountCommon,
  },
  methods: {
    goBack() {
      this.$router.push({
        path: '/console/user-manage/user-account',
      })
    },
    addAccount() {
      this.$refs.account.submitForm()
    },
  },
}
</script>

<style lang="stylus">
.add-account
  .content-wrapper
    width 558px
  .btns-wrapper
    margin-top 28px
    margin-left 96px
  .alert-info
    margin-left 96px
</style>
